import { useState } from 'react'
import Styles from './ActivityEvent.module.scss'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { ArticleService } from 'api/services/ArticleService'
import { TimelineEvent } from 'screens/Activity/Types'
import Foco from 'react-foco'

interface Props {
  event: TimelineEvent
  onEnter: () => void
  onCancel: () => void
}

const EventRenamingInput = ({ event, onCancel, onEnter }: Props) => {
  const { name: initialName } = event
  const [name, setName] = useState(initialName)

  const renameEvent = async () => {
    onEnter?.()
    const res = await ArticleService.updateEvent(event, { name })
    if (res.type !== SUCCESS_RESPONSE_TYPE) {
      setName(initialName)
    }
  }

  return (
    <Foco onClickOutside={renameEvent}>
      <input
        className={Styles.renameInput}
        autoFocus
        onFocus={({ target }) => target.select()}
        type="text"
        value={name || ''}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            onCancel()
          }
          if (e.key === 'Enter') {
            renameEvent()
          }
        }}
      />
    </Foco>
  )
}

export { EventRenamingInput }
